import { render, staticRenderFns } from "./NsMinimalHeaderLogo.vue?vue&type=template&id=107960d4&scoped=true&"
import script from "./NsMinimalHeaderLogo.vue?vue&type=script&lang=js&"
export * from "./NsMinimalHeaderLogo.vue?vue&type=script&lang=js&"
import style0 from "./NsMinimalHeaderLogo.vue?vue&type=style&index=0&id=107960d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107960d4",
  null
  
)

export default component.exports